import axios from 'axios';
import React, { useEffect, useState } from 'react';
// import env from 'react-dotenv';
import { useNavigate } from "react-router-dom";
import { DataGrid,GridToolbar} from '@mui/x-data-grid';
import { Button, Paper, TextField, Modal } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import PageHeading from '../../components/headings/pageHeading';


const InternPanel = () => {
    const navigate = useNavigate();
    const [internData,setInternData] = useState([])
    const [newIntenInfo, setnewIntenInfo] = useState({});
    const [addIntern, setaddIntern] = useState(false);
    const [refresh,setRefresh] = useState(true);

    useEffect(()=>{
        const authkey = localStorage.getItem('authKey');
        if(!authkey) navigate("/login");
    }, [])

    /* eslint no-underscore-dangle: 0 */
    const loadInternInfo = async()=>{
        const url = `${process.env.REACT_APP_BASE_URL}/intern-panel/allInterns`;
        const token = localStorage.getItem('authKey');
        const response = await axios.get(url, {headers:{'Content-Type': 'application/json', Authorization: `Bearer ${token}`}});
        const interns = [...response.data.interns]
        const tempData = [] 
        for(let index=0; index<interns.length; index+=1){
            tempData.push({
                id: index,
                intern_name:interns[index].internName,
                intern_number:interns[index].number,
                stipend:interns[index].stipend,
                paid:interns[index].ProgramInfo.paid,
                target:interns[index].ProgramInfo.target,
                manager:interns[index].ManagerInfo.managerName,
                program_name:interns[index].ProgramInfo.program_name,
                program_id: interns[index].ProgramInfo._id,
                refferals: interns[index].refferals
            })
        }
        setInternData(tempData)
    }

    const columns  = [
        { field: 'intern_name', headerName: 'Intern Name', width: 200 },
        { field: 'intern_number', headerName: 'Intern Number', width: 200 },
        { field: 'stipend', headerName: 'Pts/Money Earned', width: 200 },
        { field: 'refferals', headerName: 'Refferals', width: 200 },
        { field: 'paid', headerName: 'Paid', width: 200 },
        { field: 'target', headerName: 'Target', width: 200 },
        { field: 'manager', headerName: 'Manager', width: 200 },
        { field: 'program_name', headerName: 'Program Name', width: 200 },
        { field: 'program_id', headerName: 'Program Id', width: 200 }
      ];

    useEffect(async()=>{
        setaddIntern(false)
        loadInternInfo();
     },[refresh])

     const addInternPopup = () =>{
          setnewIntenInfo({})
          setaddIntern(true)
      }

      const updateNewInternValue = (name,value) =>{
        const temp = newIntenInfo
        temp[name]= value
        setnewIntenInfo(temp)
      }

      const createNewIntern= async() =>{
        if((newIntenInfo.name && newIntenInfo.name.length > 0) && (newIntenInfo.number && newIntenInfo.number.length ===10)){
            const url = `${process.env.REACT_APP_BASE_URL}/intern-panel/createManager`;
            const token = localStorage.getItem('authKey');
            try{
                const response = await axios.post(url,newIntenInfo, {headers:{'Content-Type': 'application/json', Authorization: `Bearer ${token}`}});
                if (response.statusCode === 200){
                    toast.success("Manager created successfully")
                    setRefresh(!refresh)
                }
            }
            catch(error){
                    toast.error("Manager with same number exists already")
                
            }
        }
        else{
            toast.error("Invalid Information")
        }
      }
    
    return ( 
        <div className="coupons w-full">
            <PageHeading heading="Intern Panel" />
                <div style={{height:"90vh" }} className='m-3'>
                <Button onClick={addInternPopup} style={{background:"#8439FF", color:"#FFFFFF", marginLeft:10, marginBottom:10}}>Add Manager</Button>
                    <DataGrid style={{width:"95%"}} rows={internData} columns={columns} 
                    components={{ Toolbar: GridToolbar }} className='bg-white w-100'/>

      <Modal
        open={addIntern}
        onClose={() => {
          setaddIntern(false);
        }}
        style={{ overflowY: "scroll" }}
      >
        <div style={{ position: "absolute",
            left: "35%",
            width: "30%",
            top: "20%"}}>
        <Paper elevation={5} style={{ padding: 2, borderRadius: 16 }}>
          <div style={{padding:10}}>
            <div style={{marginTop:10}}>
        <TextField
          required
          id="outlined-required"
          label="Manager Name"
          onChange = {(e)=>{updateNewInternValue("name",e.target.value)}}
          defaultValue={newIntenInfo.name}
          fullWidth
        />
        </div>
        <div style={{marginTop:10}}> 
        <TextField
          required
          id="outlined-required"
          label="Manager Number"
          onChange = {(e)=>{updateNewInternValue("number",e.target.value)}}
          defaultValue={newIntenInfo.number}
          fullWidth
        />
        </div>
        <div style={{marginTop:10}}>
          <Button onClick={createNewIntern}>Create</Button>  
        </div>

        </div>
        
        </Paper>
        </div>
      </Modal>
      <ToastContainer/>
                </div>
            </div>
    );
}
 
export default InternPanel;